/**
 * Creates a map of plan relationships based on the current plan
 * @param planGroups All available plan groups
 * @param currentPlanType The user's current plan type
 * @returns A map of plan types to their relationship with the current plan
 */
function createPlanComparisonMap(planGroups, currentPlanType) {
    if (!currentPlanType) {
        return {};
    }
    // Get all tiers in order from all groups
    const allTiers = [];
    for (const group of planGroups) {
        allTiers.push(...group.tiers);
    }
    // Find the index of the current plan
    const currentIndex = allTiers.findIndex((t) => t.id === currentPlanType);
    // If not found, return empty map
    if (currentIndex === -1) {
        return {};
    }
    const comparisonMap = {};
    allTiers.forEach((tier, index) => {
        if (index === currentIndex) {
            comparisonMap[tier.id] = 'current';
        }
        else if (index > currentIndex) {
            comparisonMap[tier.id] = 'upgrade';
        }
        else {
            comparisonMap[tier.id] = 'downgrade';
        }
    });
    return comparisonMap;
}
/**
 * Get the relationship of a plan compared to the current plan
 * @param planType The plan type to check
 * @param comparisonMap The comparison map
 * @returns The relationship or undefined if not found
 */
function getPlanRelationship(planType, comparisonMap) {
    return comparisonMap[planType];
}
/**
 * Get variant IDs for the same and higher tiers
 * @param planGroups All available plan groups
 * @param currentPlanType The user's current plan type
 * @returns Array of variant IDs as numbers
 */
function getSameAndHigherTierVariantIds(planGroups, currentPlanType) {
    // Get all tiers in order from all groups
    const allTiers = [];
    for (const group of planGroups) {
        allTiers.push(...group.tiers);
    }
    // Find the index of the current plan
    const currentIndex = allTiers.findIndex((t) => t.id === currentPlanType);
    // If not found, return empty array
    if (currentIndex === -1) {
        return [];
    }
    // Get all tiers from current index onwards
    const sameAndHigherTiers = allTiers.slice(currentIndex);
    // Extract variant IDs and filter out undefined values
    return sameAndHigherTiers
        .map((tier) => tier.variantId)
        .filter((id) => id !== undefined)
        .map((id) => parseInt(id, 10))
        .filter((id) => !isNaN(id));
}

export { createPlanComparisonMap, getPlanRelationship, getSameAndHigherTierVariantIds };
//# sourceMappingURL=plan-comparison.esm.js.map
